import "../styles/querycheck.css";
import React, { useState, useEffect } from 'react';
import { Check, AlertCircle } from 'lucide-react';
import { authenticatedFetch } from '../context/apiClient';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NewAssessment = () => {
  const [selectedModel, setSelectedModel] = useState('');
  const [models, setModels] = useState([]);
  const [riskCategories, setRiskCategories] = useState([]);
  const [attackVectors, setAttackVectors] = useState([]);
  const [error, setError] = useState(null);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await authenticatedFetch('/api/config', {}, user.token, logout);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setModels(data.models.map(m => ({ ...m, id: m.name, company: m.developer })));
        setRiskCategories(data.categories.map(c => ({ ...c, id: c.name, severity: c.critical, selected: true })));
        setAttackVectors([
          { id: 'Attack1', name: 'Attack 1 v1.0.1', description: '', selected: true },
          { id: 'Attack2', name: 'Attack 2 v1.0.1', description: '', selected: false },
          { id: 'Attack3', name: 'Attack 3 v1.0.1', description: '', selected: false },
          { id: 'Multi-turn', name: 'Multi-turn v1.0.0', description: '', selected: false },
          { id: 'Multilingual', name: 'Multilingual v1.0.0', description: '', selected: false },
          { id: 'Multimodal', name: 'Multimodal v1.0.0', description: '', selected: false }
        ]);
      } catch (e) {
        console.error("Failed to fetch config:", e);
        setError("Failed to load configuration. Please try again later.");
      }
    };

    fetchConfig();
  }, []);


  const [showAll, setShowAll] = useState(false);

  const visibleModels = showAll ? models : models.slice(0, 4);

  const handleModelSelect = (modelId) => {
    setSelectedModel(modelId);
  };

  const handleRiskCategoryToggle = (categoryId) => {
    setRiskCategories(prev => 
      prev.map(category => 
        category.id === categoryId 
          ? { ...category, selected: !category.selected }
          : category
      )
    );
  };

  const handleAttackVectorToggle = (vectorId) => {
    setAttackVectors(prev => 
      prev.map(vector => 
        ({ ...vector, selected: vector.id === vectorId })
      )
    );
    
  };

  const selectAllCategories = () => {
    setRiskCategories(prev => prev.map(c => ({ ...c, selected: true })));
  };

  const deselectAllCategories = () => {
    setRiskCategories(prev => prev.map(c => ({ ...c, selected: false })));
  };

  const submitNew = async () =>{
    if (!selectedModel){
       alert("Please select one model.")
       return;
    }
      
    const selected_vectores = attackVectors.filter(vector => vector.selected == true).map(item => item.id);
    const selected_categories = riskCategories.filter(item => item.selected == true).map(item => item.id);

    

    if (selected_categories.length == 0  ){
       alert("Please select at least one category.")
       return;
    }
      

    if (selected_vectores.length == 0  ){
        alert("Please select at least one method.");
        return;
    }
      
    const selectedModelObj = models.find(m => m.id === selectedModel);
    const payload = {
                "query_type": selected_categories,
                "model_name": { name: selectedModelObj?.name, model_id: selectedModelObj?.model_id },
                "method": selected_vectores[0],
                "scan_type": "jailbreak_with_guardrail"
            }
   
    try {
      const response = await authenticatedFetch('/api/scan', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      }, user.token, logout);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      navigate('/rail-history');
    } catch (e) {
      console.error("Failed to start scan:", e);
      setError("Failed to start scan. Please try again later.");
    }

  }
  const getSeverityColor = (severity) => {
    return severity === 'CRITICAL' ? 'text-red-600 bg-red-50' : 'text-yellow-600 bg-yellow-50';
  };

  const getSelectedCount = (items) => {
    return items.filter(item => item.selected).length;
  };

  const handleCancel = () => {
    
    //onCancel();
  };

  if (error) {
    return (
      <div className="flex items-center justify-center h-full text-red-500">
        <AlertCircle className="w-6 h-6 mr-2" />
        {error}
      </div>
    );
  }

  return (

   
<div className="querycheck-page">    
    <div className="container">
        <div class="section">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-xl font-bold text-gray-900 mb-2 flex items-center gap-2">
          
        Configure Guardrail Assessment
        </h1>
        <p className="text-sm text-gray-600">
        Assess the resilience of AI safety guardrails against adversarial prompt engineering and harmful content. The goal is to benchmark guardrail performance across diverse attack vectors and jailbreak methods to safeguard the backend LLM.
        </p>
      </div>

      {/* Step 1: Target Model Selection */}
      <div className="mb-6">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center text-white font-bold text-sm">
            1
          </div>
          <h2 className="text-base font-semibold text-gray-900">Step 1: Target Model Selection</h2>
        </div>
        
        <div className="grid grid-cols-5 gap-3">
          {visibleModels.map((model) => (
            <button
              key={model.id}
              onClick={() => handleModelSelect(model.id)}
              className={`p-4 rounded-lg border-2 transition-all ${
                selectedModel === model.id 
                  ? 'border-green-500 bg-green-50' 
                  : 'border-gray-200 bg-white hover:border-gray-300'
              }`}
            >
              <img src={model.icon} alt={model.name} className="w-8 h-8 rounded-lg mx-auto mb-2" />
              <h3 className="text-xs font-medium text-gray-900">{model.name}</h3>
              {model.company && (
                <p className="text-xs text-gray-500">{model.company}</p>
              )}
            </button>
          ))}

              <div
                  onClick={() => setShowAll(prev => !prev)}
                  className=" bg-gray-100 rounded-lg  cursor-pointer transition-all duration-200 hover:bg-gray-200 border-2 border-dashed border-gray-300 hover:border-gray-400 flex flex-col items-center justify-center"
                >
                  <div className="flex justify-center mb-3">
                    <div className="w-10 h-10 rounded-md flex items-center justify-center text-lg font-bold bg-gray-300 text-gray-600">
                      {showAll ? (
                        '-'
                      ) : (
                       '+'
                      )}
                    </div>
                  </div>
                  
                  <div className="text-center">
                    <h3 className="font-medium text-gray-600 mb-1 text-sm">
                      {showAll ? 'Show Less' : `+More`}
                    </h3>
                    <p className="text-xs text-gray-500">
                      {showAll ? 'Collapse' : 'Expand'}
                    </p>
                  </div>
                </div>
          
        </div>
      </div>

      {/* Step 2: Risk Assessment Categories */}
      <div className="mb-6">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center text-white font-bold text-sm">
              2
            </div>
            <h2 className="text-base font-semibold text-gray-900">Step 2: Risk Categories</h2>
            <span className="text-xs text-gray-500">({getSelectedCount(riskCategories)} total)</span>
          </div>
          <div className="flex gap-3">
            <button 
              onClick={selectAllCategories}
              className="text-xs font-medium text-blue-600 hover:text-blue-800"
            >
              Select All
            </button>
            <button 
              onClick={deselectAllCategories}
              className="text-xs font-medium text-gray-500 hover:text-gray-700"
            >
              Deselect All
            </button>
          </div>
        </div>
        
        <div className="grid grid-cols-4 gap-3">
          {riskCategories.map((category) => (
            <button
              key={category.id}
              onClick={() => handleRiskCategoryToggle(category.id)}
              className={`p-3 rounded-lg border-2 text-left transition-all ${
                category.selected 
                  ? 'border-gray-200 bg-white hover:border-gray-300' 
                  : 'border-gray-200 bg-white hover:border-gray-300'
              }`}
            >
              <div className="flex items-start gap-2">
                <div className={`w-5 h-5 rounded border-2 flex items-center justify-center mt-2 ${
                  category.selected 
                    ? 'bg-green-500 border-green-500' 
                    : 'border-gray-300'
                }`}>
                  {category.selected && <Check className="w-3 h-3 text-white" />}
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-1 mb-2">
                    <h3 className="text-xs font-medium text-gray-900">{category.name}</h3>
                    <span className={`px-1 py-0.5 rounded text-xs font-medium ${getSeverityColor(category.severity)}`}>
                      {category.severity}
                    </span>
                  </div>
                  <p className="text-xs text-gray-600 leading-relaxed">{category.description}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
        
       
      </div>

      {/* Step 3: Attack Vector Configuration */}
      <div className="mb-6">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center text-white font-bold text-sm">
              3
            </div>
            <h2 className="text-base font-semibold text-gray-900">Step 3: Attack Methods</h2>
            <span className="text-xs text-gray-500">({getSelectedCount(attackVectors)} total)</span>
          </div>
        </div>
        
        <div className="grid grid-cols-6 gap-3">
          {attackVectors.map((vector) => (
            <button
              key={vector.id}
              onClick={() => handleAttackVectorToggle(vector.id)}
              className={`p-3 rounded-lg border-2 text-left transition-all ${
                vector.selected 
                  ? 'border-gray-200 bg-white hover:border-gray-300' 
                  : 'border-gray-200 bg-white hover:border-gray-300'
              }`}
            >
              <div className="flex items-center gap-2">
                <div className={`w-5 h-5 rounded border-2 flex items-center justify-center ${
                  vector.selected 
                    ? 'bg-green-500 border-green-500' 
                    : 'border-gray-300'
                }`}>
                  {vector.selected && <Check className="w-3 h-3 text-white" />}
                </div>
                <h3 className="text-xs font-medium text-gray-900">{vector.name}</h3>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Bottom Controls */}
      

      <div className="flex justify-end mt-6 pt-4 border-t border-gray-200">
        <button className="btn-scan" id="scanBtn" onClick={submitNew}>
          Launch Assessment →
        </button>
      </div>

    </div>
  </div>
  </div>
    // </DialogContent>
    //       <DialogActions className="!px-8 !pb-3 !border-t !border-[#DCDFE9] !pt-3">
    //         <button
    //           onClick={handleCancel}
    //           className="bg-[#EAECF2CC] text-sm text-[#42444D] rounded-[6px] w-[80px] h-[40px]"
    //         >
    //           Cancel
    //         </button>
    //         <button
    //           onClick={submitNew}
              
    //           className={`text-sm rounded-[6px] w-[165px] h-[40px] text-white font-medium ${
    //             "bg-[#22c55e]"
    //           }`}
    //         >
    //           Launch Assessment &#x2192;
    //         </button>
    //       </DialogActions>
    //     </Dialog>

  );
};

export default NewAssessment;
